<script setup lang="ts">
import { ref, inject, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useGroupTypeStore } from '@/store/GroupTypeStore';
import { useToast } from 'primevue/usetoast';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import InputText from 'primevue/inputtext';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

const dialogRef = inject('dialogRef') as Ref;
const showError = ref(false);
const closeModal = dialogRef?.value.options.emits.closeModal;
const data = ref(dialogRef?.value.options.props.data);

const { t } = useI18n({ useScope: 'global' });
const toast = useToast();
const isLoading = ref(false);

const groupTypeManagement = useGroupTypeStore();

const submitGroupType = () => {
  if (data.value.name.trim() && data.value.nameFr.trim()) {
    isLoading.value = true;
    groupTypeManagement
      .addGroupType(data.value)
      .then(() => {
        toast.add({ severity: 'success', summary: '', detail: t('notification.save_successfully'), life: 3000 });
        closeModal();
      })
      .catch(() => {
        toast.add({ severity: 'error', summary: '', detail: t('notification.save_error'), life: 5000 });
      })
      .finally(() => {
        isLoading.value = false;
      });
  } else {
    showError.value = true;
  }
};
</script>

<template>
  <LoadingSpinner v-if="isLoading" />
  <div class="update-group-type">
    <div class="create-group-type-modal">
      <label for="group-type-name">{{ t('management.group_type.group_type_name') }}</label>
      <InputText id="group-type-name" type="text" v-model="data.name" :maxlength="100" class="w-full" :class="showError && !data.name.trim() ? 'p-invalid' : ''" @focus="showError = false"></InputText>
      <p class="text-red-500 pt-1" v-if="showError && !data.name.trim()">{{ $t('validate.required') }}</p>
    </div>
    <div class="create-group-type-modal mt-3">
      <label for="group-type-name-fr">{{ t('management.group_type.group_type_name_fr') }}</label>
      <InputText id="group-type-name-fr" type="text" v-model="data.nameFr" :maxlength="100" class="w-full" :class="showError && !data.nameFr.trim() ? 'p-invalid' : ''" @focus="showError = false"></InputText>
      <p class="text-red-500 pt-1" v-if="showError && !data.nameFr.trim()">{{ $t('validate.required') }}</p>
    </div>
    <div v-if="!data.sk" class="create-group-type-modal mt-3">
      <div>
        <Checkbox id="group-type-add-hotel" v-model="data.addToHotel" :binary="true" />
        <label for="group-type-add-hotel" class="ml-1">{{ $t('management.group_type.apply_to_all_hotels') }}</label>
      </div>
    </div>
    <div class="btn-center">
      <Button :label="$t('common.buttons.submit')" @click="submitGroupType()" />
    </div>
  </div>
</template>
